import React, { useState, useEffect } from 'react';
import { BarChart3, TrendingUp, Clock } from 'lucide-react';
import axios from 'axios';
import './Analytics.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Analytics = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  const linkNames = {
    'frequency-room': 'Join This Month\'s Virtual Frequency Room',
    'way-forward': 'The Way Forward™ Course',
    'hair-ritual': 'Get Your Custom Hair Ritual',
    'business-expand': 'Curious About the Business?',
    'bend-meetups': 'Located in Bend, OR?'
  };

  useEffect(() => {
    fetchStats();
    // Refresh stats every 30 seconds
    const interval = setInterval(fetchStats, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/click-stats`);
      setStats(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching stats:', error);
      setLoading(false);
    }
  };

  const getTotalClicks = () => {
    return stats.reduce((sum, stat) => sum + stat.click_count, 0);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="analytics-container">
        <div className="analytics-card">
          <p className="loading-text">Loading analytics...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="analytics-container">
      <div className="analytics-card animate-fade-in-up">
        <div className="analytics-header">
          <div className="header-title">
            <BarChart3 size={28} />
            <h1 className="heading-1">Link Analytics</h1>
          </div>
          <div className="total-clicks-badge">
            <TrendingUp size={18} />
            <span>{getTotalClicks()} Total Clicks</span>
          </div>
        </div>

        <div className="stats-grid stagger-children">
          {Object.entries(linkNames).map(([linkId, linkName]) => {
            const stat = stats.find(s => s.link_id === linkId);
            const clickCount = stat ? stat.click_count : 0;
            const lastClicked = stat ? stat.last_clicked : null;

            return (
              <div key={linkId} className="stat-card hover-lift">
                <div className="stat-header">
                  <h3 className="stat-title">{linkName}</h3>
                </div>
                <div className="stat-content">
                  <div className="stat-number">{clickCount}</div>
                  <div className="stat-label">Clicks</div>
                </div>
                {lastClicked && (
                  <div className="stat-footer">
                    <Clock size={14} />
                    <span className="last-clicked-text">
                      Last: {formatDate(lastClicked)}
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <button onClick={fetchStats} className="refresh-button hover-scale">
          Refresh Stats
        </button>
      </div>
    </div>
  );
};

export default Analytics;
